import PropTypes from 'prop-types'
import React, { useMemo } from 'react'

import Avatar from 'components/common/Avatar'
import { userTypes } from 'helpers/user'
import { getIdentity } from 'hooks/useParticipants/useParticipants'

import { ParticipantTile, Name, AvatarWrapper } from './styles'

import {
    getParticipantList,
    getParticipantTileSize,
} from '../../helper/participants'

const Participants = ({ participants = [] }) => {
    const listOfParticipantsInClass = useMemo(() => {
        const size = getParticipantTileSize('participant-tile')
        if (!participants.length) return null
        if (isNaN(size)) return null
        let list = []

        getParticipantList(participants).forEach(item => {
            if (item) {
                const { name, user, position } = item
                const participantProps = {
                    position,
                    size,
                    name,
                }

                const isTeacher = name.toLowerCase() === userTypes.TEACHER

                const userType = isTeacher
                    ? userTypes.TEACHER
                    : userTypes.STUDENT

                const identity = getIdentity(`:${name}`)
                const firstName = identity.firstName.toLowerCase()

                list.push(
                    <ParticipantTile {...participantProps} key={user}>
                        <AvatarWrapper>
                            <Avatar uuid={user} userType={userType} />
                        </AvatarWrapper>
                        <Name {...participantProps}>{firstName}</Name>
                    </ParticipantTile>
                )
            }
        })
        return list
    }, [participants])

    return listOfParticipantsInClass
}

Participants.propTypes = { participants: PropTypes.array.isRequired }

export default Participants
